var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgErrorCircleX = function SvgErrorCircleX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M6.48 5.42a.75.75 0 0 0-1.06 1.06L6.94 8 5.42 9.52a.75.75 0 0 0 1.06 1.06L8 9.06l1.52 1.52a.75.75 0 1 0 1.06-1.06L9.06 8l1.52-1.52a.75.75 0 1 0-1.06-1.06L8 6.94z",
    clipRule: "evenodd"
  })));
};
export default SvgErrorCircleX;